"use client";

import React from "react";
import { X, Check } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";

/**
 * WebsiteForTradespeople — Section 2: Problem-Lösung-Split
 * Drop-in für: src/pages/WebsiteForTradespeople/sections/RoleOverviewResponsibilities.tsx
 */

const problems = ["Mundpropaganda allein reicht nicht mehr", "Keine Referenzen online = weniger Vertrauen", "Potenzielle Kunden rufen die Konkurrenz an"];
const solutions = ['Lokale SEO: „Maler + Ihre Stadt" auf Google', "Referenzen-Galerie mit Vorher/Nachher-Bildern", "Anfrage-Formular: Neue Aufträge direkt per Mail"];
export default function RoleOverviewResponsibilities() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section className="bg-secondary py-20 md:py-24">
      <div ref={ref} className={`max-w-5xl mx-auto px-4 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-start">
          <div>
            <h2 className="text-3xl md:text-4xl font-bold tracking-tight text-foreground mb-6 leading-tight">
              Ihre besten Aufträge kommen über Google
            </h2>
            <p className="text-lg text-muted-foreground leading-relaxed mb-6">
              Wenn jemand „Maler Zürich" oder „Elektriker St. Gallen" sucht,
              finden sie Ihre Konkurrenz — nicht Sie. Ohne Website verlieren Sie
              täglich Aufträge, die Sie leicht gewinnen könnten.
            </p>
            <ul className="space-y-4">
              {problems.map((p, i) => <li key={i} className="flex items-start gap-3">
                  <span className="mt-1 inline-flex h-5 w-5 items-center justify-center rounded-full bg-red-100 text-red-500 shrink-0">
                    <X className="w-3 h-3" strokeWidth={3} />
                  </span>
                  <span className="text-foreground/90">{p}</span>
                </li>)}
            </ul>
          </div>

          <div>
            <h2 className="text-3xl md:text-4xl font-bold tracking-tight text-primary mb-6 leading-tight">
              PAGEMAKER24 löst das
            </h2>
            <p className="text-lg text-muted-foreground leading-relaxed mb-6">
              Erstellen Sie Ihre professionelle Handwerker-Website in einer
              Stunde — mit Referenzen, Leistungen und Kontaktformular.
            </p>
            <ul className="space-y-4">
              {solutions.map((s, i) => <li key={i} className="flex items-start gap-3">
                  <span className="mt-1 inline-flex h-5 w-5 items-center justify-center rounded-full bg-green-100 text-green-600 shrink-0">
                    <Check className="w-3 h-3" strokeWidth={3} />
                  </span>
                  <span className="text-foreground/90">{s}</span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}